import { Grid, Typography } from '@mui/material';
import { SubHeader } from 'features/Principal/PrincipalCandidatesList/styles';
import { PrincipalAppPreferences } from 'features/Principal/types/candidatesListTypes';
import React from 'react';
import { getRolePreferences, getSchoolPreferences } from '../../utils';
import { OverviewItem } from './CandidateOverview';

export interface CandidatePreferencesProps {
  preferences: PrincipalAppPreferences;
}

export const CandidatePreferences: React.FC<CandidatePreferencesProps> = ({ preferences }) => {
  const rolePreferences = getRolePreferences(preferences);
  const schoolPreferences = getSchoolPreferences(preferences);

  return (
    <>
      <SubHeader variant="h3">Candidate Preferences</SubHeader>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Typography>{'Role Preferences'.toUpperCase()}</Typography>
        </Grid>
        <Grid item xs={6}>
          {rolePreferences
            ?.slice(0, 2)
            .map((data, index) => <OverviewItem data={data} key={index} />)}
        </Grid>
        <Grid item xs={6}>
          {rolePreferences?.slice(2).map((data, index) => <OverviewItem data={data} key={index} />)}
        </Grid>
        <Grid item xs={12}>
          <Typography>{'School Preferences'.toUpperCase()}</Typography>
        </Grid>
        <Grid item xs={6}>
          {schoolPreferences
            ?.slice(0, 2)
            .map((data, index) => <OverviewItem data={data} key={index} />)}
        </Grid>
        <Grid item xs={6}>
          {schoolPreferences
            ?.slice(2)
            .map((data, index) => <OverviewItem data={data} key={index} />)}
        </Grid>
      </Grid>
    </>
  );
};
